<mat-toolbar class="mat-toolbar">
    <mat-nav-list>
        <mat-list-item>
            Pacientes
            <button (click)="createPatient()" mat-mini-fab>
        <mat-icon>add</mat-icon>
      </button>
        </mat-list-item>
    </mat-nav-list>
</mat-toolbar>
<mat-nav-list>
    <mat-list-item (click)="selectPatient(patient)" *ngFor="let patient of patients">
        <div mat-line>
            {{ patient.LastName }}
        </div>
        <p mat-line>
            {{ patient.FirstName }}
        </p>
    </mat-list-item>
</mat-nav-list>